const actions = {
  CREATE_MEMBER_LIST: 'CREATE_MEMBER_LIST',
  CREATE_MEMBER_LIST_END: 'CREATE_MEMBER_LIST_END',
  SEARCH_MEMBER_LISTS: 'SEARCH_MEMBER_LISTS',
  SEARCH_MEMBER_LISTS_END: 'SEARCH_MEMBER_LISTS_END',
  DELETE_MEMBER_LISTS: 'DELETE_MEMBER_LIST',
  DELETE_MEMBER_LISTS_END: 'DELETE_MEMBER_LIST_END',
  CREATE_MEMBER_LIST_BATCH: 'CREATE_MEMBER_LIST_BATCH',
  CREATE_MEMBER_LIST_BATCH_END: 'CREATE_MEMBER_LIST_BATCH_END',
  SEARCH_MEMBER_LIST_BATCH: 'SEARCH_MEMBER_LIST_BATCH',
  SEARCH_MEMBER_LIST_BATCH_END: 'SEARCH_MEMBER_LIST_BATCH_END',
  DELETE_MEMBER_LIST_BATCH: 'DELETE_MEMBER_LIST_BATCH',
  DELETE_MEMBER_LIST_BATCH_END: 'DELETE_MEMBER_LIST_BATCH_END',
  SEARCH_MEMBER_LIST_BATCH_ROW: 'SEARCH_MEMBER_LIST_BATCH_ROW',
  SEARCH_MEMBER_LIST_BATCH_ROW_END: 'SEARCH_MEMBER_LIST_BATCH_ROW_END',
  GET_MEMBER_LIST_STATUS_OF_PROGRESS: 'GET_MEMBER_LIST_STATUS_OF_PROGRESS',
  GET_MEMBER_LIST_STATUS_OF_PROGRESS_END: 'GET_MEMBER_LIST_STATUS_OF_PROGRESS_END',
};

export default actions;
